import React from "react";
import { Card, CardContent } from "../ui/card";

export interface EmptyStateProps {
  icon: React.ElementType;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <Card className="border-brand-steel/50 bg-white shadow-sm w-full">
      <CardContent className="px-5 py-1">
        <div className="flex flex-col items-center justify-center text-center py-8">
          <Icon size={64} className="text-brand-steel/30 mb-6" aria-hidden="true" />
          <h3 className="text-base font-semibold text-gray-700 mb-1">{title}</h3>
          {description && (
            <p className="text-sm text-brand-steel/70 max-w-xs">{description}</p>
          )}
          {action && <div className="mt-6">{action}</div>}
        </div>
      </CardContent>
    </Card>
  );
}

export default EmptyState;
